import type { Hotels } from '@entities/avail'
import * as React from 'react'

interface AvailContextProps {
  availList: Hotels[]
  setAvailList: React.Dispatch<React.SetStateAction<Hotels[]>>
  availListAux: Hotels[]
  setAvailListAux: React.Dispatch<React.SetStateAction<Hotels[]>>
  cardShowing: boolean
  setCardShowing: (value: boolean) => void
}

// eslint-disable-next-line
export const AvailContext = React.createContext<AvailContextProps>(
  {} as AvailContextProps,
)

AvailContext.displayName = 'AvailContext'
export const AvailContextProvider = ({
  children,
}: {
  children: React.ReactNode
}): JSX.Element => {
  const cacheCardShowing: boolean = !!localStorage.getItem('cardShowing')

  const [availList, setAvailList] = React.useState<Hotels[]>([])
  const [availListAux, setAvailListAux] = React.useState<Hotels[]>([])
  const [cardShowing, setCardShowing] = React.useState(cacheCardShowing)

  return (
    <AvailContext.Provider
      value={{
        availList,
        setAvailList,
        availListAux,
        setAvailListAux,
        cardShowing,
        setCardShowing,
      }}
    >
      {children}
    </AvailContext.Provider>
  )
}

export const useAvail = (): AvailContextProps => {
  const context = React.useContext(AvailContext)

  if (!context) {
    throw new Error('useAvail must be used within a AvailContextProvider')
  }

  return context
}
